export const positiveIntegerPattern: RegExp = /^[0-9]+$/;
